module.exports = __webpack_public_path__ + "static/media/icon1.ac302d40.png";